import { useState } from 'react';
import { useSnackbar } from 'notistack';
import { AxiosError } from 'axios';
import { npsEnabledStart } from '../api';

function useEnabledStart() {
  const [state, setState] = useState<{
    loading: boolean;
    error: boolean;
  }>({ loading: false, error: false });

  const { enqueueSnackbar } = useSnackbar();

  async function handleEnabledStart() {
    try {
      setState({ loading: true, error: false });

      await npsEnabledStart();
    } catch (error) {
      const message = (error as AxiosError).response?.data?.message;

      setState({ loading: false, error: message });
      enqueueSnackbar(message, { variant: 'info', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
    } finally {
      setState({ loading: false, error: false });
    }
  }

  return { handleEnabledStart, enabledStartState: state };
}

export default useEnabledStart;
